import { commonResources } from "./common";
import { attendanceFormlayoutResources } from "./layout";
import { learnerDetailsFormResources } from "./learnerDetailsForm";
import { trainerDetailsFormResources } from "./trainerDetailsForm";

export const enResources = {
  attendanceFormlayout: attendanceFormlayoutResources,
  trainerDetailsForm: trainerDetailsFormResources,
  learnerDetailsForm: learnerDetailsFormResources,
  common: commonResources,
};
